<template>
    <ToggleGroupRoot :model-value="modelValue" required type="single" class="inline-block" @update:model-value="onSelected">
        <div class="flex items-start border shadow-xs rounded-lgr">
            <ToggleGroupItem
                v-for="option of options"
                :key="option.key?.toString()"
                :value="option.key"
                class="px-4 py-2 hover:bg-toggle-option-hover data-[state=on]:bg-toggle-option-selected flex items-center justify-center bg-control-bg text-toggle-text first:rounded-l-lgr last:rounded-r-lgr first:border-none border-l body-small">
                {{ option.label }}
            </ToggleGroupItem>
        </div>
    </ToggleGroupRoot>
</template>

<script setup lang="ts">
import { type AcceptableValue, ToggleGroupItem, ToggleGroupRoot } from "reka-ui";

type BaseSingleToggleGroupProps = {
    options: { key: AcceptableValue; label: string }[];
    modelValue: AcceptableValue;
};

defineProps<BaseSingleToggleGroupProps>();

const emit = defineEmits<{
    "update:modelValue": [payload: AcceptableValue];
}>();

const onSelected = (newKey: AcceptableValue) => {
    if (!newKey) {
        // If newKey is falsy, the user tried to unselect the current option, but we need exactly
        // one option to be selected at all times, so we ignore these events.  (This is also why we
        // don't simply let the v-model binding pass through automatically).
        return;
    }

    emit("update:modelValue", newKey);
};
</script>
